import { ErrorLogComponent } from '@cian/error-log-component';
import { Responsive, UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer, PageContainerMobile } from '../PageContainer';
import { HelmetContainer } from '../HelmetContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { deviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={deviceType}>
          <Provider store={reduxStore}>
            <HelmetContainer />
            <Responsive desktop>
              <PageContainer />
            </Responsive>
            <Responsive tablet phone>
              <PageContainerMobile />
            </Responsive>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
